import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { IMAGES } from 'shared/constants/imagePaths.constants';
import { ToastService } from 'shared/services';
import { unsubscribeFromAll } from 'shared/util/unsubscribeFromAll';

enum FormFragmentsEnum {
    LOGIN,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    CHANGE_PASSWORD,
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./../../../authentication/authentication.scss', './login.component.scss'],
    standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
    public visibleFragment = FormFragmentsEnum.LOGIN;
    public FormFragmentsEnum = FormFragmentsEnum;
    protected IMAGES = IMAGES;
    private subscriptions: { [key: string]: Subscription } = {};

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private toastService: ToastService,
    ) {
        this.subscriptions.combinedData = combineLatest([this.activatedRoute.url, this.activatedRoute.params]).subscribe(
            ([url, params]) => {
                if (params.requestId) {
                    this.visibleFragment = FormFragmentsEnum.RESET_PASSWORD;
                } else if ((url?.length === 1 && url[0].path === 'change-password') || params.passwordChangeRequestId) {
                    this.visibleFragment = FormFragmentsEnum.CHANGE_PASSWORD;
                } else if (url?.length === 1 && url[0].path !== 'login') {
                    this.visibleFragment = FormFragmentsEnum.FORGOT_PASSWORD;
                }
            },
        );
    }

    ngOnInit(): void {
        // Remove all toasts, except the ones that are forced to show
        this.toastService.removeAll(false);
    }

    ngOnDestroy(): void {
        unsubscribeFromAll(this.subscriptions);
    }

    navigateToHome(isLoggedIn: boolean) {
        if (isLoggedIn) {
            const returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || '';
            const url = new URL(returnUrl, window.location.origin);
            const path = url.pathname;
            const queryParams = Object.fromEntries(url.searchParams.entries());

            this.router.navigate([path], { queryParams }).then();
        }
    }
}
